import { render, staticRenderFns } from "./DeleteBlog.vue?vue&type=template&id=37a546a0"
import script from "./DeleteBlog.vue?vue&type=script&lang=js"
export * from "./DeleteBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports